import Main from "_c/main"

export default {
    path: "/",
    name: "",
    component: Main,
    children: [
        {
            path: "/System",
            name: "System",
            component: () => import('@/view/System'),
            meta:{
                parent:true,
                parentName:"System",
                name:"系统",
                assess:true
            },
            children: [
                {
                    path: "user",
                    name: "user",
                    component: () => import("@/view/System/user"),
                    meta:{
                        parent:false,
                        parentName:"System",
                        name:"用户分配",
                        assess:true
                    }
                },
                {
                    path: "role",
                    name: "role",
                    component: () => import("@/view/System/role"),
                    meta:{
                        parent:false,
                        parentName:"System",
                        name:"角色管理",
                        assess:true
                    }
                },
                {
                    path: "log",
                    name: "log",
                    component: () => import("@/view/System/log"),
                    meta:{
                        parent:false,
                        parentName:"System",
                        name:"查看日志",
                        assess:true
                    }
                },
            ]
        }
    ]

}


// WEBPACK FOOTER //
// ./src/router/modules/System.js